export default "__VITE_ASSET__KdLXJmjC__"